
export default {
    name: 'two_column_text_block',
    props:{
        section:Object,
        first:Boolean,
    }
}


// WEBPACK FOOTER //
// ./src/components/content/two_column_text_block/two_column_text_block.js